// src/pages/layout/Layout.jsx
import { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

export default function Layout({ children }) {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  return (
    <div id="app">
      <Sidebar isOpen={isOpen} closeSidebar={closeSidebar} />
      <div id="main">
        <Navbar toggleSidebar={toggleSidebar} />
        {isOpen && <div className="overlay" onClick={closeSidebar}></div>}
        <div className="main-content container-fluid">{children}</div>
        <footer>
          <div className="footer clearfix mb-0 text-muted">
            <div className="float-left">
              <p>2025 &copy; PERUMDAM TKR</p>
            </div>
            <div className="float-right">
              <p>
                Created with{" "}
                <span className="text-danger">
                  <i data-feather="heart"></i>
                </span>{" "}
                by <a>PERUMDAM TKR</a>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
